export const REAUTH_TEXT_KEYS = {
  signIn: 'com.tempedge.msg.label.sign_in',
  description: 'com.tempedge.msg.chatbot.error_session_expired',
  sessionReplacedDescription: 'com.tempedge.error.session.replaced',
  sessionNotValidDescription: 'com.tempedge.error.session.notvalid',
  refreshTokenInvalidDescription: 'com.tempedge.error.session.refreshtokeninvalid',
  networkDescription: 'com.tempedge.msg.error.networkerror',
  otpDescription: 'com.tempedge.msg.reauth.otp_desc',
  otpLabel: 'com.tempedge.msg.label.code',
  submitting: 'com.tempedge.msg.reauth.submitting',
  leave: 'com.tempedge.msg.reauth.leave',
  username: 'com.tempedge.msg.label.username',
  password: 'com.tempedge.msg.label.password'
};

/**
 * Dictionary key of the message each reason shows. The reasons the API reports carry the key it sends in
 * `errorKey`; a lost connection shows the network message; the rest (inactivity, a 401 with no body) fall
 * back to the generic expired-session key.
 */
const DESCRIPTION_BY_REASON = {
  session_replaced: REAUTH_TEXT_KEYS.sessionReplacedDescription,
  session_not_valid: REAUTH_TEXT_KEYS.sessionNotValidDescription,
  refresh_rejected: REAUTH_TEXT_KEYS.refreshTokenInvalidDescription,
  connection_lost: REAUTH_TEXT_KEYS.networkDescription,
  refresh_unreachable: REAUTH_TEXT_KEYS.networkDescription
};

export const getReauthDescriptionKey = (reason) => DESCRIPTION_BY_REASON[reason] || REAUTH_TEXT_KEYS.description;
